/**
 * Remove all HTML tags from a string
 * except bulleted lists, numbered lists, paragraphs, breaks, and bold font
 * @param {string} htmlString
 */
const removeHTML = htmlString => {
	if (!htmlString) {
		return '';
	}
	// Strip out anything between < and >
	// keep br, caption, div, em, li, ol, p, span, strong, sub, sup, table, tbody, td, th, tr, and ul tags
	return htmlString.replace(
		/<(?!\/?br\s*\/?)(?!\/?caption\s*\/?)(?!\/?div\s*\/?)(?!\/?em\s*\/?)(?!\/?li\s*\/?)(?!\/?ol\s*\/?)(?!\/?p\s*\/?)(?!\/?img\s*\/?)(?!\/?span\s*\/?)(?!\/?strong\s*\/?)(?!\/?sub\s*\/?)(?!\/?sup\s*\/?)(?!\/?table\s*\/?)(?!\/?tbody\s*\/?)(?!\/?td\s*\/?)(?!\/?th\s*\/?)(?!\/?tr\s*\/?)(?!\/?ul\s*\/?)[^>]+>/gm,
		'',
	);
};

export default removeHTML;
